<template>
    <div class="data-manager-side-form-container">
        <ClearData :is-side-form="true" v-if="type == 'clear-data'" />
        <DeleteAccount :is-side-form="true" v-if="type == 'delete-account'"/>
    </div>
</template>

<script>
import ClearData from "@/new/components/Settings/DataManager/ClearData.vue";
import DeleteAccount from "@/new/components/Settings/DataManager/DeleteAccount.vue";

export default {
    name: "DataManagerSideForm",

    components: {
        ClearData,
        DeleteAccount
    },

    props: ['type'],
}
</script>

<style scoped lang="scss">
.data-manager-side-form-container {
    height: 100%;

    .clear-data-form,
    .delete-account-form {
        height: 100%;
    }
}
</style>